export const closeAllToastsEventHandler = (notyf) => {
    notyf.dismissAll();
};
